import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { FermeService } from './ferme.service';
import { AuthenticationService } from '../auth.service';
import { Ferme } from '../../models/ferme.model';

/** Canonical ferme ID within a tenant's Datastore namespace. */
const DEFAULT_FERME_ID = 1;

@Injectable({ providedIn: 'root' })
export class FermeStateService {

  private ferme$ = new BehaviorSubject<Ferme | null>(null);

  readonly ferme: Observable<Ferme | null> = this.ferme$.asObservable();

  get snapshot(): Ferme | null {
    return this.ferme$.getValue();
  }

  /** Use this everywhere instead of a local `const FERME_ID = 1`. */
  get fermeId(): number {
    return this.snapshot?.id ?? DEFAULT_FERME_ID;
  }

  constructor(private fermeService: FermeService, private authService: AuthenticationService) {}

  /** Appelé une seule fois au démarrage dans AppComponent */
  load(): void {
    // Seulement une fois connecté : l'API exige un jeton (sinon 401 sur la page de connexion)
    this.authService.getIdToken().catch(() => null).then(token => {
      if (!token) { return; }
      this.fetchFerme();
    });
  }

  private fetchFerme(): void {
    this.fermeService.getById(DEFAULT_FERME_ID).pipe(
      tap(f => this.ferme$.next(f)),
      catchError(() => of(null))
    ).subscribe();
  }

  /** Mise à jour locale après sauvegarde du profil */
  update(ferme: Ferme): void {
    this.ferme$.next(ferme);
  }
}
